import React from "react";
import { FormattedNumericInput } from "features/../../../shared/components/forms";
import { Form } from "@redriver/cinnamon";
import { Grid, Image } from "semantic-ui-react";
import { MeteredServiceDropdown } from "features/../../../shared/components/forms";
import { IconButton } from "features/../../../shared/components/buttons";
import Add from "features/../../../shared/assets/blue-add.svg";
import Remove from "features/../../../shared/assets/red-delete.svg";

const ReturnOnInvestmentForm = ({ formProps, dealerOfficeId }) => (
  <Form {...formProps} className="return-on-investment-form">
    <Grid>
      <Grid.Row>
        <Grid.Column width={16}>
          <Form.Input
            fluid
            required
            field="name"
            label="Name"
            className="highlighted-input"
            placeholder="Name..."
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="compact">
        <Grid.Column width={8}>
          <Form.Checkbox field="availableToSheet" label="Available to sheet" />
        </Grid.Column>
        <Grid.Column width={8}>
          <Form.Checkbox
            field="defaultOnSheetView"
            label="Default on sheet view"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="compact">
        <Grid.Column width={8}>
          <Form.Checkbox
            field="defaultOnCustomerView"
            label="Default on Customer view"
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className="compact">
        <Grid.Column width={16}>
          <Form.ArrayAdder
            field="meteredServices"
            arrayKey="id"
            as={IconButton}
            icon={Add}
            content="Add Metered Service"
            populate={() => ({
              id: Date.now(),
              meteredServiceId: null,
              count: 0,
            })}
          />
        </Grid.Column>
      </Grid.Row>

      <Grid.Row className="compact metered-service-headers">
        <Grid.Column width={8}>Metered Services</Grid.Column>
        <Grid.Column width={5}>Number of Counts</Grid.Column>
        <Grid.Column width={3}></Grid.Column>
      </Grid.Row>

      <Form.Array field="meteredServices" arrayKey="id">
        {({ arrayIndex }) => (
          <Grid.Row className="compact">
            <Grid.Column width={8}>
              <MeteredServiceDropdown
                field="meteredServiceId"
                fluid
                required
                search
                selection
                className="highlighted-input"
                dealerOfficeId={dealerOfficeId}
                availableOnly
                useDisplayName
              />
            </Grid.Column>
            <Grid.Column width={3} className="count-column">
              <FormattedNumericInput
                required
                field="count"
                width={4}
                minValue={0}
                maxValue={9999}
                decimalPlaces={0}
              />
            </Grid.Column>
            <Grid.Column width={5} className="remover-column">
              <Form.ArrayRemover className="remover">
                <Image src={Remove} />
              </Form.ArrayRemover>
            </Grid.Column>
          </Grid.Row>
        )}
      </Form.Array>
    </Grid>
  </Form>
);

export default ReturnOnInvestmentForm;
